import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/check.svg';
import MerchantReinsurance from '~/components/molecules/Product/MerchantReinsurance.vue';
import ProductOffers from '~/components/molecules/Product/ProductOffers.vue';
export default {
  name: 'Reinsurance',
  components: {
    MerchantReinsurance,
    ProductOffers
  },
  props: {
    deliveryPayload: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    activeDeliveryPayload() {
      const openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES'];
      return openStores.includes(this.locale.iso);
    },

    deliveryUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/statique/livraison.htm");
    },

    returnsUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/retour-gratuit.htm");
    }

  }),
  methods: {
    handleClickDelivery(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Livraison',
          event_label: 'Clic_FAQ_Livraison'
        }
      });
    },

    handleClickReturns(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Retours',
          event_label: 'Clic_FAQ_Retours'
        }
      });
    }

  }
};